import { c as _c } from "react/compiler-runtime";
import { DragHandleDots2Icon as GripVerticalIcon } from '@radix-ui/react-icons';
import clsx from 'clsx';
import * as React from 'react';
import * as ResizablePrimitive from 'react-resizable-panels';
import { cn } from '@/lib/utils';
type ResizablePanelGroupProps = React.ComponentProps<typeof ResizablePrimitive.Group> & {
  direction?: ResizablePrimitive.Orientation;
};
function ResizablePanelGroup(t0) {
  const $ = _c(12);
  let className;
  let direction;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      direction,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = direction;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    direction = $[2];
    props = $[3];
    t1 = $[4];
  }
  const orientation = t1 === undefined ? direction : t1;
  const t2 = orientation ?? "horizontal";
  let t3;
  if ($[5] !== className) {
    t3 = cn("flex size-full data-[panel-group-direction=vertical]:flex-col", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== orientation || $[8] !== props || $[9] !== t2 || $[10] !== t3) {
    t4 = <ResizablePrimitive.Group data-slot="resizable-panel-group" data-panel-group-direction={t2} className={t3} orientation={orientation} {...props} />;
    $[7] = orientation;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function ResizablePanel(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function ResizableHandle(t0) {
  const $ = _c(12);
  let className;
  let props;
  let withHandle;
  if ($[0] !== t0) {
    ({
      withHandle,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = withHandle;
  } else {
    className = $[1];
    props = $[2];
    withHandle = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:outline-hidden aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:translate-x-0 aria-[orientation=horizontal]:after:-translate-y-1/2 [&[aria-orientation=horizontal]>div]:rotate-90", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== withHandle) {
    t2 = withHandle && <div className={clsx("z-10 flex h-4 min-w-3 items-center justify-center rounded-xs border bg-border", "sq:rounded-xl")}><GripVerticalIcon className="size-2.5" /></div>;
    $[6] = withHandle;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <ResizablePrimitive.Separator data-slot="resizable-handle" className={t1} {...props}>{t2}</ResizablePrimitive.Separator>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export { ResizableHandle, ResizablePanel, ResizablePanelGroup };